import dayjs from "dayjs";
import advancedFormat from 'dayjs/plugin/advancedFormat';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(advancedFormat);

const dateLong = (date: dayjs.ConfigType) => {
  return dayjs(date).format('MMMM D, YYYY');
}

const dateTimeWithTimezone = (date: dayjs.ConfigType) => {
  return dayjs(date).format('DD/MM/YYYY HH:mm (z)');
}

const isAfterUTC = (date: dayjs.ConfigType, afterDate: dayjs.ConfigType) => {
  return dayjs(date).utc().isAfter(dayjs(afterDate).utc(true));
}

const Format = {
  dateLong,
  dateTimeWithTimezone
}

const Utils = {
  isAfterUTC
}

const DateTime = {
  Format,
  Utils
}

export default DateTime;
